export enum MODAL_SELECTORS {
  WALLET_CONNECT = "WALLET_CONNECT",
  UNSUPPORTED_NETWORK = "UNSUPPORTED_NETWORK",
  REGION_RESTRICTED = "REGION_RESTRICTED",
}
